import React from 'react'
import { Container } from './styles'
import { getBiologicalSexOf, getImageBodyRepresentationOf, getSkinColorOf } from './utils'
import { Images } from '~/assets/images'
import { usePatient } from '~/context'

export const HumanBody = (): JSX.Element => {
  const { patient } = usePatient()

  const biologicalSex = getBiologicalSexOf(patient)
  const skinColor = getSkinColorOf(patient)
  const ethnicalGroupImages = Images.body[biologicalSex][skinColor]

  const PatientHumanBody = getImageBodyRepresentationOf(patient)(ethnicalGroupImages)

  return <Container data-testid="human-body-container">{PatientHumanBody && <PatientHumanBody />}</Container>
}
